<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="车间">
        <el-select v-model="query.workShopId" clearable filterable size="small" style="width:140px" @change="loadCenters">
          <el-option v-for="item in shops" :key="item.workShopId" :label="item.workShopName" :value="item.workShopId" />
        </el-select>
      </el-form-item>
      <el-form-item label="机台">
        <el-select v-model="query.workCenterId" clearable filterable size="small" style="width:160px">
          <el-option v-for="item in centers" :key="item.workCenterId" :label="item.workCenterCode + ' ' + item.workCenterName" :value="item.workCenterId" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:workCenterDowntime:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('base:workCenterDowntime:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="workCenterCode" label="机台" min-width="100">
        <template slot-scope="scope">
          <span v-if="isAuth('base:workCenterDowntime:info') || isAuth('base:workCenterDowntime:list')" class="code-link" @click="open(scope.row.downtimeId, true)">{{ scope.row.workCenterCode }}</span>
          <span v-else>{{ scope.row.workCenterCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="workShopName" label="车间" min-width="90" />
      <el-table-column prop="downtimeStart" label="开始" min-width="140" />
      <el-table-column prop="downtimeEnd" label="结束" min-width="140" />
      <el-table-column prop="reason" label="原因" min-width="120" show-overflow-tooltip />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />
    <work-center-downtime-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WorkCenterDowntimeAddOrUpdate from './workCenterDowntime-add-or-update'

export default {
  name: 'WorkCenterDowntime',
  components: { WorkCenterDowntimeAddOrUpdate },
  data() {
    return {
      query: { workShopId: '', workCenterId: '' }, shops: [], centers: [], list: [],
      pageIndex: 1, pageSize: 20, loading: false, hasActivated: false, addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.loadShops(); this.loadCenters(); this.load() },
  activated() {
    if (this.hasActivated) { this.loadShops(); this.loadCenters(); this.load() }
    else this.hasActivated = true
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    loadShops() { request.post('/base/workShop/list', { currentPage: 1, pageSize: 500 }).then(res => { this.shops = (res.data && res.data.list) || [] }).catch(() => {}) },
    loadCenters() {
      this.query.workCenterId = ''
      request.get('/production/workCenter/list', { params: { workShopId: this.query.workShopId } }).then(res => { this.centers = res.data || [] }).catch(() => {})
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/production/downtime/list', { params: this.query }).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, !!readonly, { workCenterId: this.query.workCenterId || '' }))
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
